import React, { type ReactNode } from 'react'
import cn from 'classnames'

interface DetailLabelProps {
  label: string
  value: ReactNode
  additionalOuterClasses?: string
}

const PlainDetailLabel: React.FC<DetailLabelProps> = ({ label, value, additionalOuterClasses }) => {
  return (
    <div className={cn(additionalOuterClasses, 'flex flex-col')}>
      <label className="text-sm text-gray-600">{label}</label>
      <div className="text-gray-600 text-lg">{value}</div>
    </div>
  )
}

export default PlainDetailLabel
